// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"ConfirmReportDialog_modalContent__3JYIX","btnLink":"ConfirmReportDialog_btnLink__3Tbby","closeIcon":"ConfirmReportDialog_closeIcon__1WWEi"};